"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BatchResult {
}
exports.BatchResult = BatchResult;
